<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body form">
      <div class="del-block" v-if="show.delBtn">
        <div class="btn btn-danger" data-toggle="modal" data-target="#delModal">刪除出單機</div>
      </div>
      <br  v-if="show.delBtn" />
      <br />
      <!-- cr start-->
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>識別碼
        </span>
          <input class="form-control" placeholder="" type="text" v-model="content.identity" maxlength="45">
        </div>
        <br />
      </div>
      <div>
        <div class="input-group">
        <span class="input-group-addon">
          <span class="text-red">＊ </span>類型
        </span>
          <div class="form-group">
            <select class="form-control" v-model="content.type">
              <option :value="1">W牌出單機(1)</option>
              <option :value="2">F牌出單機(2)</option>
              <option :value="3">F牌貼紙機(3)</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <!-- up start -->
      <div  v-if="info">
        <div class="input-group">
        <span class="input-group-addon">
          啟用
        </span>
          <div class="form-group">
            <select class="form-control" v-model="content.is_enabled">
              <option value="1">啟用</option>
              <option value="0">不啟用</option>
            </select>
          </div>
        </div>
        <br />
      </div>
      <!-- up end -->
      <!-- /.box-body -->
    </div>
    <div class="box-footer text-center">
      <router-link to="/printerTable">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" v-if="!info" @click="checkPrinter('cr')">
        新增
      </button>
      <button class="btn btn-success" v-if="info" @click="checkPrinter('up')">
        修改
      </button>
    </div>
    <br />
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>
<script>
import matcherModal from '../../../elements/Modal.vue'
export default {
  props: {
    'info': {
      type: Object
    }
  },
  components: {
    'm-modal': matcherModal
  },
  data () {
    return {
      phone: '',
      radioRoleType: 'admin',
      delOption: {
        id: 'delModal',
        title: '刪除出單機',
        body: '確定刪除?<br>刪除此出單機，將無法再用此帳號登入！',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delPrinter'
          }
        ]
      },
      show: {
        delBtn: false
      },
      content: {
        identity: '',
        type: 1,
        is_enabled: 1
      }
    }
  },
  methods: {
    trigger (event) {
      if (event === 'delPrinter') {
        this.delPrinter()
      }
    },
    checkPrinter (type) {
      var msg = ''
      if (!this.content.identity) {
        msg = '請輸入辨識碼'
      }
      this.getToast(msg, type)
    },
    getToast (msg, type) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (type === 'cr') this.addPrinter()
        else if (type === 'up') this.upPointer()
      }
    },
    addPrinter () {
      var self = this
      var url = '/printer'
      var info = this.content
      var data = {
        type: info.type,
        identity: info.identity
      }
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/printerTable')
        }
      })
    },
    upPointer () {
      var self = this
      var url = '/printer/' + this.$route.params.printer_id
      var info = this.content
      var data = {
        type: info.type,
        identity: info.identity,
        is_enabled: info.is_enabled
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/printerTable')
        }
      })
    },
    delPrinter () {
      var self = this
      var url = '/printer/' + this.$route.params.printer_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.replace('/printerTable')
        }
      })
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    info () {
      const info = this.info
      this.content = {
        identity: info.printer_identity,
        type: info.printer_type,
        is_enabled: info.printer_is_enabled
      }
      this.show.delBtn = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrinterFormTemp.vue?29c9190b